import { Directive, ElementRef, forwardRef, HostListener } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Directive({
  selector: '[nimbusMatMeridian][formControlName],[nimbusMatMeridian][formControl],[nimbusMatMeridian][ngModel]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MatMeridianDirective),
      multi: true,
    },
  ],
  standalone: false,
})
export class MatMeridianDirective implements ControlValueAccessor {
  private readonly VALID_SYMBOLS: string[][] = [['A', 'P'], ['M']];

  private onControlChanged: (value: string) => void;

  private readonly lengthLimit: number = 2;

  public constructor(private elementRef: ElementRef<HTMLInputElement>) {}

  public registerOnChange(fn: (value: string) => void): void {
    this.onControlChanged = fn;
  }

  public registerOnTouched(fn: () => {}): void {}

  public registerOnValidatorChange(fn: () => void): void {}

  @HostListener('input', ['$event'])
  public onInput(event: KeyboardEvent): void {
    const inputValue: string = (event.target as HTMLInputElement).value.toUpperCase();
    this.parseInputValue(inputValue.substr(0, this.lengthLimit));
  }

  private parseInputValue(inputValue: string): void {
    let result: string = inputValue;

    for (let i = 0; i < inputValue.length; i++) {
      if (!this.VALID_SYMBOLS[i].includes(inputValue[i])) {
        result = result.replace(inputValue[i], '');
      }
    }

    if (this.onControlChanged) {
      this.onControlChanged(result);
    }
    this.elementRef.nativeElement.value = result;
  }

  public writeValue(value: string): void {
    const inputValue: string = value;
    this.elementRef.nativeElement.value = inputValue;
  }
}
